import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Login from '../views/Login.vue';
import PasswordReset from '../views/PasswordReset.vue';
import Sites from '../views/Sites.vue';
import AddSite from '../views/AddSite.vue';
import AddShaft from '../views/AddShaft.vue';
import Shaft from '../views/Shaft.vue';
import EditShaft from '../views/EditShaft.vue';
import EditBuildup from '../views/EditBuildup.vue';
import Orders from '../views/Orders.vue';
import Contact from '../views/Contact.vue';
import LegalNotice from '../views/LegalNotice.vue';
import OrderSummary from '../views/OrderSummary.vue';
import AppBarDefault from '../components/AppBarDefault.vue';
import AppBarEmpty from '../components/AppBarEmpty.vue';
import { store } from '@/store';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    meta: {
      requiresLoading: true,
    },
    components: {
      default: Home,
      navigation: AppBarDefault,
    },
  },
  {
    path: '/login',
    name: 'login',
    components: {
      default: Login,
      navigation: AppBarEmpty,
    },
  },
  {
    path: '/passwort-reset',
    name: 'reset',
    meta: {
      isPublic: true,
    },
    components: {
      default: PasswordReset,
      navigation: AppBarEmpty,
    },
  },
  {
    path: '/baustellen',
    name: 'sites',
    meta: {
      requiresLoading: false,
    },
    components: {
      default: Sites,
      navigation: AppBarDefault,
    },
  },
  {
    path: '/baustellen/:id',
    name: 'site',
    meta: {
      requiresLoading: false,
    },
    components: {
      default: Sites,
      navigation: AppBarDefault,
    },
  },
  {
    path: '/baustelle/neu',
    name: 'addsite',
    meta: {
      requiresLoading: false,
    },
    components: {
      default: AddSite,
      navigation: AppBarDefault,
    },
  },
  {
    path: '/schacht/add',
    name: 'addshaft',
    meta: {
      requiresLoading: false,
    },
    components: {
      default: AddShaft,
      navigation: AppBarDefault,
    },
  },
  {
    path: '/schacht/:id',
    name: 'shaft',
    meta: {
      requiresLoading: true,
    },
    components: {
      default: Shaft,
      navigation: AppBarDefault,
    },
  },
  {
    path: '/schacht/:id/boden',
    name: 'shaftbase',
    meta: {
      requiresLoading: false,
    },
    components: {
      default: EditShaft,
      navigation: AppBarDefault,
    },
  },
  {
    path: '/schacht/:id/aufbau',
    name: 'shaftbuildup',
    meta: {
      requiresLoading: false,
    },
    components: {
      default: EditBuildup,
      navigation: AppBarDefault,
    },
  },
  {
    path: '/bestellungen',
    name: 'orders',
    meta: {
      requiresLoading: false,
    },
    components: {
      default: Orders,
      navigation: AppBarDefault,
    },
  },
  {
    path: '/kontakt',
    name: 'contact',
    meta: {
      requiresLoading: false,
    },
    components: {
      default: Contact,
      navigation: AppBarDefault,
    },
  },
  {
    path: '/impressum',
    name: 'legalnotice',
    meta: {
      isPublic: true,
      requiresLoading: false,
    },
    components: {
      default: LegalNotice,
      navigation: AppBarDefault,
    },
  },
  {
    path: '/bestellung',
    name: 'ordersummary',
    meta: {
      isPublic: true,
      requiresLoading: true,
    },
    components: {
      default: OrderSummary,
      navigation: AppBarEmpty,
    },
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,

  scrollBehavior(to, from, savedPosition) {
    let position = { x: 0, y: 0 };
    if (to.hash) return { selector: to.hash };
    if (savedPosition) {
      position = savedPosition;
      store.dispatch('setIsBack', true);
      return new Promise(resolve => {
        setTimeout(() => {
          resolve(position);
        }, 2000);
      });
    }
    store.dispatch('setIsBack', false);
    return position;
  },
  routes,
});

router.beforeEach(async (to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.isPublic);
  if (!isPublic) {
    // forward to login if not authenticated
    const isLoggedIn = store.getters.isLoggedIn;
    if (!isLoggedIn && to.name !== 'login') {
      return next('/login');
    }
  }

  // check loading
  const requiresLoading = to.matched.some(
    record => record.meta.requiresLoading,
  );
  if (requiresLoading) store.dispatch('setLoading', true);

  return next();
});

export default router;
